/* eslint-disable jsx-a11y/no-static-element-interactions */
import { useRef } from 'react'
import ReactDOM from 'react-dom'
import classNames from 'classnames'

import s from './Overlay.module.css'

// TODO: Setup proptypes
function Overlay({
  children,
  className,
  close,
  hideClose,
  transparent,
  darkCloseIcon,
}) {
  const container = useRef(null)

  if (typeof document === 'undefined') return null

  const handleClick = (e) => {
    // console.log('overlay handlclick', e.target, container.current)
    if (e.target === container.current) close(e)
  }

  return ReactDOM.createPortal(
    <div // eslint-disable-line jsx-a11y/click-events-have-key-events
      role="presentation"
      onClick={handleClick}
      ref={container}
      className={classNames(s.container, className, {
        [s.transparent]: transparent,
      })}
    >
      {children}
      {!hideClose && (
        <button
          type="button"
          aria-label="Close overlay"
          className={s.close}
          onClick={close}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            className={s.closeIcon}
            viewBox="0 0 16 16"
          >
            <path
              fill={darkCloseIcon ? '#000000' : '#ffffff'}
              d="M15.556.707L14.849 0 7.778 7.071.707 0 0 .707l7.071 7.071L0 14.849l.707.707 7.071-7.071 7.071 7.071.707-.707-7.071-7.071z"
            />
          </svg>
        </button>
      )}
    </div>,
    document.body
  )
}

export default Overlay
